var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{attrs:{"id":"clear__section"},on:{"click":_vm.clearFilters}},[_c('GjIcon',{attrs:{"name":"Close","size":"16"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }